import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { PublicCosmeticDetails } from '../models/public-cosmetic-details';
import { PublicCosmeticApiService } from '../api/services/public-cosmetic-api.service';
import { PublicCosmeticCharacteristic } from '../models/public-cosmetic-characteristic';
import { PublicCosmeticAttribute } from '../models/public-cosmetic-attribute';
import { multimediaFromResponse } from '@web/shared/module/multimedia';
import { PublicCosmeticBrand } from '../models/public-cosmetic-brand';
import { PublicCosmeticBox } from '../models/public-cosmetic-box';
import { executeOrNull } from '@web/utils';
import { publicSalesFromResponse } from '@web/shared/module/shop';

@Injectable({
  providedIn: 'root',
})
export class PublicCosmeticDataSourceService {
  private readonly cosmeticApi = inject(PublicCosmeticApiService);

  public fetchDetailsBySlug(
    slug: string,
    cacheable = true,
  ): Observable<PublicCosmeticDetails> {
    return this.cosmeticApi.fetchDetailsBySlug(slug, cacheable).pipe(
      map(
        (response) =>
          new PublicCosmeticDetails({
            box: executeOrNull(
              response.box,
              (box) =>
                new PublicCosmeticBox({
                  slug: box.slug,
                  name: box.name,
                  sales: publicSalesFromResponse(box.sales),
                  id: box.id,
                }),
            ),
            slug: response.slug,
            id: response.id,
            characteristics: response.characteristics.map(
              (characteristic) =>
                new PublicCosmeticCharacteristic({
                  content: characteristic.value,
                  id: characteristic.id,
                  label: characteristic.label,
                }),
            ),
            attributes: response.attributes.map(
              (attribute) =>
                new PublicCosmeticAttribute({
                  content: attribute.value,
                  id: attribute.id,
                  label: attribute.productAttribute.label,
                }),
            ),
            cosmeticBrand: new PublicCosmeticBrand({
              id: response.cosmeticBrand.id,
              name: response.cosmeticBrand.name,
              slug: response.cosmeticBrand.slug,
              logo: multimediaFromResponse(response.cosmeticBrand.logo),
            }),
            vendorUrl: response.vendorUrl,
            name: response.name,
            files: response.files.map((file) => multimediaFromResponse(file)),
          }),
      ),
    );
  }
}
